import PropTypes from "prop-types";
import styles from "./utility-area.module.less";
import { DateHelper, PrimaryButton, PrimaryButtonLink, Icon } from "@parksandresorts/core";
import SiteConfigurationStore from "components/stores/site-configuration-store";

const UtilityArea = (props) => {
  const recurringLabel = SiteConfigurationStore.getLabel("UTILITY_AREA_NEXT_OCCASION", "Nästa tillfälle");

  const textContentProvided =
    props.location || props.nextShowTime || props.minimumHeight || props.couponCount ? true : false;
  const onlyShowCustomText = props.hideEventDateAndOnlyShowCustomText && props.customDateText;
  const onlyShowCustomTime = props.hideEventDateAndOnlyShowCustomText && props.customDateTime;

  return (
    <div
      className={[
        styles.utilityOuterWrapper,
        textContentProvided ? styles.withTextContent : null,
        props.visible ? styles.visible : "",
      ].join(" ")}
    >
      {props.visible && textContentProvided && (
        <div className={["block--padded", styles.utilityWrapper, props.extraClass].join(" ")}>
          {props.recurring && <span className={styles.recurringLabel}>{recurringLabel}:</span>}
          {props.visible &&
            ((props.nextShowTime && DateHelper.isDateValid(props.nextShowTime)) || onlyShowCustomText) && (
              <span className={[styles.utilityShowText, "p_small"].join(" ")}>
                <Icon name="calendar" className={styles.utilityIcon} />
                {props.nextShowTime && !onlyShowCustomText && (
                  <span
                    className={[
                      styles.utilityAreaTime,
                      props.customDateText || props.isCancelled ? styles.strikethrough : "",
                    ].join(" ")}
                  >
                    {DateHelper.toStringDDMonth(props.nextShowTime)}
                  </span>
                )}
                {props.customDateText && (
                  <span className={[styles.utilityAreaTime, "p_small"].join(" ")}>{props.customDateText}</span>
                )}
              </span>
            )}
          {props.visible &&
            ((props.nextShowTime && DateHelper.isDateValid(props.nextShowTime)) || onlyShowCustomTime) && (
              <span className={[styles.utilityShowText, "p_small"].join(" ")}>
                <Icon name="clock" className={styles.utilityIcon} />
                {!props.customDateTime && (
                  <span className={[styles.utilityAreaTime, props.isCancelled ? styles.strikethrough : ""].join(" ")}>
                    {DateHelper.toStringTimeHHMM(props.nextShowTime)}
                  </span>
                )}
                {props.customDateTime && (
                  <span className={[styles.utilityAreaTime, "p_small"].join(" ")}>{props.customDateTime}</span>
                )}
              </span>
            )}
          {props.visible && props.location && (
            <span className={[styles.utilityShowText, "p_small"].join(" ")}>
              <Icon name="location" className={styles.utilityIcon} />
              <span className={[styles.utilityAreaTime, props.isCancelled ? styles.strikethrough : ""].join(" ")}>
                {props.location}
              </span>
            </span>
          )}
          {props.visible && props.minimumHeight && (
            <span className={[styles.utilityShowText, "p_small"].join(" ")}>
              <span className={["icon-length", styles.utilityIcon].join(" ")} />
              <span className={styles.utilityAreaTime}>{props.minimumHeight}</span>
            </span>
          )}
          {props.visible && props.couponCount && (
            <span className={[styles.utilityShowText, "p_small"].join(" ")}>
              <Icon name="ticket" className={styles.utilityIcon} />
              <span className={styles.utilityAreaTime}>
                {props.couponCount + " " + SiteConfigurationStore.getLabel("COUPONS")}
              </span>
            </span>
          )}
        </div>
      )}
      {props.buttonLabel &&
        props.visible &&
        !props.buttonDisabled &&
        (props.buttonLink || props.onClickButton) &&
        (props.buttonLink ? (
          <PrimaryButtonLink url={props.buttonLink} className={styles.buyBtn} label={props.buttonLabel} />
        ) : (
          <PrimaryButton onClick={() => props.onClickButton()} className={styles.buyBtn} label={props.buttonLabel} />
        ))}
    </div>
  );
};

UtilityArea.propTypes = {
  onClickButton: PropTypes.func,
  recurring: PropTypes.bool,
};

export default UtilityArea;
